import { render, staticRenderFns } from "./ColorSelectionItem.vue?vue&type=template&id=226ac611&"
import script from "./ColorSelectionItem.vue?vue&type=script&lang=js&"
export * from "./ColorSelectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports